import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-copyright">
          Copyright © inUtil Labs 2019 - {new Date().getFullYear()}
        </div>
        <div className="footer-links">
          <a href="https://inutil-labs.com/legal" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a href="https://inutil-labs.com/tos" target="_blank" rel="noopener noreferrer">Terms of Services</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 